import { AxiosResponse } from 'axios';
import { ColumnDTO, exportFile, GetItemsProps } from 'medere-ui-framework';
import { axiosInstance } from '../App';
import { Sector } from '../interface/interface';
import { SECURED_API_BASE } from './apiConfig';
import { normalizeFilterDTO } from './remoteTableFilters';
import {
    RepositoryExportFilter,
    RepositoryItemChangeDTO,
    RepositoryItemDTO,
    RepositoryPermissionsDTO,
    RepositoryStockItemOptionDTO,
    StockMovementPageDTO,
} from '../dto/SectorRepositoryDTO';

const BASE = `${SECURED_API_BASE}/sector-repositories`;

export interface StockSectorListParams {
    multiSortMeta?: unknown;
    filterDTO?: unknown;
    activeFilter?: boolean[];
}

export function getStockSectors(offSet: number, pageSize: number, params: StockSectorListParams = {}): Promise<Sector[]> {
    return axiosInstance.post(`${BASE}/sectors/list`, {
        loadConfigDTO: {
            offSet,
            pageSize,
            sortingFieldInfoList: params.multiSortMeta,
            filters: normalizeFilterDTO(params.filterDTO),
        },
        activeFilter: params.activeFilter ?? [],
    }).then(r => r.data ?? []);
}

export function getRepositoryPermissions(): Promise<RepositoryPermissionsDTO> {
    return axiosInstance.get(`${BASE}/permissions`).then(r => r.data);
}

export function getRepositoryItems(sectorId: number): Promise<RepositoryItemDTO[]> {
    return axiosInstance.get(`${BASE}/${sectorId}/items`).then(r => r.data ?? []);
}

export function saveRepositoryItems(sectorId: number, items: RepositoryItemChangeDTO[]): Promise<RepositoryItemDTO[]> {
    return axiosInstance.put(`${BASE}/${sectorId}/items`, { items }).then(r => r.data ?? []);
}

export function searchRepositoryStockItems({ filterValue, offSet, pageSize }: GetItemsProps): Promise<RepositoryStockItemOptionDTO[]> {
    return axiosInstance.get(`${BASE}/stock-item-presentations`, {
        params: { inputText: filterValue ?? '', offSet, pageSize },
    }).then(r => r.data ?? []);
}

export function getRepositoryItemMovements(repositoryDetailId: number, offSet: number, pageSize: number): Promise<StockMovementPageDTO> {
    return axiosInstance.get(`${BASE}/items/${repositoryDetailId}/movements`, { params: { offSet, pageSize } }).then(r => r.data);
}

export function exportRepositoryItems(sectorId: number, filter: RepositoryExportFilter, columns: ColumnDTO[]): Promise<AxiosResponse> {
    return exportFile(`${BASE}/${sectorId}/items/export`, { columns }, filter);
}
